export default [
    {
        path: '/tasks',
        props: true,
        component: () => import('@/views/Task/ByUser'),
    },
    {
        path: '/tasks/user-group',
        props: true,
        component: () => import('@/views/Task/ByUserGroup'),
    },
];
